import { defaultFetch } from './baseApi';

export type FinancialProgress = {
	amount: number;
	cashedAmount: number;
	finalAmount: number;
	month: number;
	posizioneSottovoceDiSpesa: number;
	posizioneVoceDiSpesa: number;
	projectExpenseItemId: number;
	projectId: number;
	sottovoceDiSpesa: string;
	voceDiSpesa: string;
	year: number;
};

export const getFinancialProgresses = async (projectID: string) => {
	return defaultFetch<FinancialProgress[]>(`/v0/projects/${projectID}/financialprogresses`);
};

export type CashedInProgress = {
	projectId: number;
	cashedInAmount: number;
	month: number;
	year: number;
};

export const getCashedInProgresses = async (projectID: string) => {
	return defaultFetch<CashedInProgress[]>(`/v0/projects/${projectID}/cashedinprogresses`);
};

export type CompleteFinancialProgress = FinancialProgress & CashedInProgress;
